export default __webpack_public_path__ + "static/media/golf.7de2b2e9.png";